export default __webpack_public_path__ + "static/better-way-91bea491f5d6f44aa9e46efc1faf67e9.jpg";